// extracted by mini-css-extract-plugin
export default {"side_main_menu":"SideMainMenu_side_main_menu__2F11v","frame":"SideMainMenu_frame__lOfQV","title":"SideMainMenu_title__NEmyh"};